/**
 * Displays a heading showing current search term or selected elements
 */
import React, { useContext } from "react";
import { PeriodicTableContext } from "./PeriodicTableContext";

const ResultsHeading = () => {
  const { selectedElements, formulaSearchTerm } = useContext(
    PeriodicTableContext
  );

  let searchResultsText = "";

  if (selectedElements.length) {
    searchResultsText = selectedElements.join(" + ");
  }

  if (formulaSearchTerm) {
    searchResultsText = formulaSearchTerm;
  }

  return (
    <h1 className="section-title products-section-title">
      Search results for {searchResultsText}
    </h1>
  );
};

export default ResultsHeading;
